import { gql } from '@/lib/graphql/gql'

export const COMPANY_USERS_QUERY = gql`
  query CompanyUsers($idCompany: String!) {
    company(id: $idCompany) {
      id
      name
      projects @live {
        id
        items {
          id
          displayName
        }
      }
      apps @live {
        id
        items {
          id
          displayName
        }
      }
      databases @live {
        id
        items {
          id
          displayName
        }
      }
      staticSites @live {
        id
        items {
          id
          displayName
        }
      }
      objectStorages @live {
        id
        items {
          id
          displayName
        }
      }
      edgeLoadBalancers @live {
        id
        items {
          id
          displayName
        }
      }
      users @live {
        id
        user {
          id
          email
          image
          firstName
          lastName
          fullName
          type2FA
        }
        capabilities @live {
          id
          idCompany
          idApp
          idDatabase
          idStaticSite
          idObjectStorage
          idLoadBalancer
          idProject
          idRole
          type
          permissions {
            id
            type
            key
            idCompany
            idApp
            idDatabase
            idStaticSite
            idObjectStorage
            idLoadBalancer
          }
        }
      }
      pendingInvitations @live {
        id
        email
        capabilities {
          id
          idCompany
          idApp
          idDatabase
          idStaticSite
          idObjectStorage
          idLoadBalancer
          idProject
          idRole
          type
          permissions {
            id
            type
            key
            idCompany
            idApp
            idDatabase
            idStaticSite
            idObjectStorage
            idLoadBalancer
          }
        }
      }
    }
    user @live {
      id
      email
      image
      fullName
    }
  }
`
